import { render, staticRenderFns } from "./CoUserProfileEditor.vue?vue&type=template&id=c329d91e&scoped=true&"
import script from "./CoUserProfileEditor.vue?vue&type=script&lang=ts&"
export * from "./CoUserProfileEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CoUserProfileEditor.vue?vue&type=style&index=0&id=c329d91e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c329d91e",
  null
  
)

export default component.exports